import React from "react";
import PropTypes from "prop-types";
import { take as _take } from "lodash";
import moment from "moment";
import Translation from "../../../commons/i18n/Translation";
import Constants from "../../configurations/Constants";
import { CommonsConstants } from "../../../commons";
import Svg from "../../../../svg/Svg";

class UserPostRow extends React.Component {

    render = () => {
        if(this.props.post)
            return (
                <article className="pure-g user-module__article">
                    <div className="pure-u-20-24">
                        <a href={this.props.post.permaLink}>
                            <div className="user-module__title">{this.props.post.title}</div>
                            <div className="user-module__date">{moment(this.props.post.publishedAt).format(CommonsConstants.SIMPLE_DATE_DISPLAY_FORMAT[Translation.getLanguageName()])}</div>
                        </a>
                    </div>
                    <div className="pure-u-4-24">
                        <a href={"/" + Translation.getLanguageName() + "/mywort/edit#/post/" + this.props.post.id}><Svg id="watermark-blog" className="icon user-module__left__icon u-hover-primary-color"/></a>
                    </div>
                </article>
            );

    };
}

export default class UserPostList extends React.Component {

    static propTypes = {
        posts: PropTypes.array.isRequired,
        totalPostsCount: PropTypes.number.isRequired
    };

    static defaultProps = {
        posts: [],
        totalPostsCount: 0
    };

    render = () => {
        if (this.props.posts.length === 0)
            return (
                <article className="user-module__article">
                    <div className="pure-u-1 pure-u-sm-24-24 pure-u-lg-24-24">
                      <div className="user-module__title">{Translation.translate("user-module.empty-post")}</div>
                    </div>
                </article>
            );

        return (
            <div>
                { _take(this.props.posts, Constants.USER_MODULE_POSTS_LIMIT).map( (post) => <UserPostRow key={'userpost-'+post.id} post={post}/> ) }
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/components/user-module/UserPostList.jsx